/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { ALL_DISCOUNT } from "../graphql/GetDiscountCodes.query";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IAllDiscountListsMethods extends IPluginMethodMap {
  getAllDiscountListsProps(args: any): Promise<any>;
}

export class AllDiscountListsService implements IAgentPlugin {
  readonly methods: IAllDiscountListsMethods;

  constructor() {
    this.methods = {
      getAllDiscountListsProps: this.getAllDiscountListsProps.bind(this),
    };
  }

  async getAllDiscountListsProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: ALL_DISCOUNT,
          variables: {
            filter: {},
          },
          fetchPolicy: "network-only",
        });
        console.log(this.transformData(
          res?.data?.getAllDiscounts?.content
        ));
        return {
          discountLists: this.transformData(
            res?.data?.getAllDiscounts?.content
          ),
          discountEntireData: res?.data?.getAllDiscounts?.content,
        };
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }
  private transformData(inputData: any) {
    return inputData.map((item: any) => {
      return {
        id: item?._id,
        label: item.name,
        discountType: item.discountType,
        section: item?.section?.id,
        sectionOptType: item?.sectionOptType?.id,
        presentation: item?.presentation?._id
      };
    });
  }
}
